import * as S from "./SideMenuList.style";
import { SideMenuItem } from "@/components/atoms/SideMenuItem";
import { useRecoilValue } from "recoil";
import { loginTypeState } from "@/common/states/user";

interface SideMenuListProps {
  data: any;
}

export const SideMenuList = ({ data }: SideMenuListProps) => {
  const loginType = useRecoilValue(loginTypeState);

  const filterData = data.filter((item: any) => {
    if (item.id === 2 || item.id === 3 || item.id === 4) {
      return loginType === "student";
    }
    return true;
  });
  return (
    <S.SideMenuList>
      {filterData.map((item: any, idx: number) => {
        return <SideMenuItem item={item} key={idx} />;
      })}
    </S.SideMenuList>
  );
};
